export default __webpack_public_path__ + "static/media/image4.7c18fb7c.jpg";